import PropTypes from 'prop-types'
import React, { useState, useImperativeHandle, useRef, useMemo } from 'react'
import { Colors } from 'Theme'
import styles from './IFDateRangePicker.module.css'
import { IFText, IFsvg } from 'Components'
import { DateRangePicker } from 'rsuite'
import { getTextWidth } from '../../../Utils/Calculations'
import isAfter from 'date-fns/isAfter'

// Default time for a freshly picked range: start at 00:00, end at 23:59 — most
// filtering is by whole day. rsuite copies these times onto the clicked days,
// and the time panel stays available if a specific hour is needed.
const buildDefaultCalendarValue = () => {
  const start = new Date()
  start.setHours(0, 0, 0, 0)
  const end = new Date()
  end.setHours(23, 59, 59, 999)
  return [start, end]
}

const IFDateRangePicker = React.forwardRef(
  (
    {
      title,
      onDateRangeSelected = () => {},
      initialValue,
      ranges,
      disableFutureDates = false,
    },
    ref,
  ) => {
    const [value, setValue] = useState(initialValue)
    const [isOpen, setIsOpen] = useState(false)
    const defaultCalendarValue = useMemo(() => buildDefaultCalendarValue(), [])

    const clearValue = () => {
      setValue([])
      onDateRangeSelected([])
    }

    useImperativeHandle(ref, () => ({
      clearValue,
      isOpen,
    }))
    const pickerRef = useRef()

    return (
      <div ref={pickerRef} className={styles.wrapperContainer}>
        <div className={styles.container}>
          <DateRangePicker
            container={() => pickerRef?.current}
            style={{
              width: getTextWidth(title, `600 ${14}px ProximaNova`) + 16,
            }}
            onOpen={() => setIsOpen(true)}
            format="yyyy-MM-dd HH:mm:ss"
            defaultCalendarValue={defaultCalendarValue}
            value={value.length !== 0 ? value : null}
            onClose={() => setIsOpen(false)}
            onOk={(value) => {
              setValue(value)
              onDateRangeSelected(value)
            }}
            cleanable={false}
            size="lg"
            placeholder={title}
            renderValue={() => (
              <div>
                <IFText style={{ color: 'white' }}>{title}</IFText>
              </div>
            )}
            className={styles.DateRange}
            ranges={ranges}
            onChange={(value) => {
              setValue(value)
              onDateRangeSelected(value)
            }}
            disabledDate={
              disableFutureDates ? (date) => isAfter(date, new Date()) : null
            }
          />

          <div className={styles.TextWrapper}>
            <IFText className={styles.Text}>
              {/* {Replacing all spaces with &nbsp; for styling} */}
              {title.replaceAll(' ', '\u00a0')}
            </IFText>
            <div>
              <IFsvg.Expand
                height={20}
                width={20}
                fill={Colors.FilterIconFilled}
              />
            </div>
          </div>
        </div>
      </div>
    )
  },
)

IFDateRangePicker.propTypes = {
  title: PropTypes.string.isRequired,
  onDateRangeSelected: PropTypes.func.isRequired,
  initialValue: PropTypes.array,
}

export default IFDateRangePicker
